import { p as prisma } from "../../../../chunks/prisma.js";
import { startOfWeek, endOfWeek, isToday } from "date-fns";
const housekeeping = async () => {
  const now = /* @__PURE__ */ new Date();
  const start = startOfWeek(now, { weekStartsOn: 1 });
  const end = endOfWeek(now, { weekStartsOn: 1 });
  await prisma.task.updateMany({
    where: { dueDate: { gte: start, lte: end }, column: { not: "THIS_WEEK" } },
    data: { column: "THIS_WEEK" }
  });
  const todays = await prisma.task.findMany({ where: { dueDate: { gte: start, lte: end } } });
  let base = -1e5;
  for (const t of todays) {
    if (t.dueDate && isToday(t.dueDate)) {
      await prisma.task.update({ where: { id: t.id }, data: { sort_order: base++ } });
    }
  }
};
const GET = async ({ url, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  await housekeeping();
  const q = url.searchParams.get("q") ?? void 0;
  const categoryId = url.searchParams.get("categoryId") ?? void 0;
  const where = {};
  if (q) where.OR = [{ title: { contains: q } }, { description: { contains: q } }];
  if (categoryId) where.categoryId = categoryId;
  const tasks = await prisma.task.findMany({ where, orderBy: [{ column: "asc" }, { sort_order: "asc" }], include: { category: true } });
  return new Response(JSON.stringify(tasks));
};
const POST = async ({ request, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  const body = await request.json();
  const task = await prisma.task.create({ data: {
    title: body.title,
    description: body.description ?? "",
    categoryId: body.categoryId ?? null,
    dueDate: body.dueDate ? new Date(body.dueDate) : null,
    column: body.column ?? "IDEAS",
    sort_order: body.sort_order ?? 1e3,
    recurrence_day_of_month: body.recurrence_day_of_month ?? null
  } });
  return new Response(JSON.stringify(task), { status: 201 });
};
export {
  GET,
  POST
};
